import pt_BR from './translations/pt_BR';
import en_US from './translations/en_US';

export default {
  pt_BR,
  en_US
};